// extracted by mini-css-extract-plugin
export default {"base":"LinkageHistory_base__9g+os","cell":"LinkageHistory_cell__1eykS","dropDownSelection":"LinkageHistory_dropDownSelection__u583Y"};